// src/ProtectedRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ Component }) => {
  const isAllowed = sessionStorage.getItem("demoSubmitted") === "true";
  return isAllowed ? <Component /> : <Navigate to="/" replace />;
};

export default ProtectedRoute;
